import { v7 as uuidv7 } from 'uuid'
import { getMeta, setMeta } from './db.js'

/**
 * The install id. COMPLIANCE §2: a random id per install and nothing else, no advertising id,
 * no fingerprint.
 */
export async function deviceId(): Promise<string> {
  const existing = await getMeta<string>('deviceId')
  if (existing) return existing
  const created = uuidv7()
  await setMeta('deviceId', created)
  return created
}

export async function activeChildId(): Promise<string | null> {
  return (await getMeta<string>('activeChildId')) ?? null
}

export async function setActiveChildId(childId: string | null): Promise<void> {
  await setMeta('activeChildId', childId)
}
